import { Drawer } from '@/components';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import type { FC } from 'react';
import { useProjectDetailDrawerState } from '../../_components/ProjectDrawerStateProvider';
import { RelatedMaterialForm } from './RelatedMaterialForm';

export const RelatedMaterialFormDrawer: FC = () => {
  const { id } = useId();
  const project = useProject(id);

  const { drawerState, setDrawerState } = useProjectDetailDrawerState();

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'related-material'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnHidden
    >
      <RelatedMaterialForm
        initialIndonesiaData={
          project.data?.indonesiaData ? project.data?.indonesiaData : undefined
        }
        initialValues={{
          evaluationOfProgramResults:
            project.data?.indonesiaData?.evaluationOfProgramResults,
          usulanPerbaikan: project.data?.indonesiaData?.usulanPerbaikan,
          referensiProgramYangSamaDiDaerahLain:
            project.data?.indonesiaData?.referensiProgramYangSamaDiDaerahLain,
          catatan: project.data?.indonesiaData?.catatan,
        }}
      />
    </Drawer>
  );
};
